export function redirect(url: string) {
  window.location.assign(url);
}

export function getReferrer(): string {
  return document.referrer;
}
